export var SET_SCHEMA = "SET_SCHEMA";
export var SET_PARSED_SCHEMA = "SET_PARSED_SCHEMA";
export var FETCH_SCHEMA = "FETCH_SCHEMA";
export var FETCH_AND_PARSE_SCHEMA = "FETCH_AND_PARSE_SCHEMA";
export var PARSE_AND_SET_SCHEMA = "PARSE_AND_SET_SCHEMA";
export var SET_SCHEMA_ELEMENT_VALUE = "SET_SCHEMA_ELEMENT_VALUE";
export var UPDATE_SCHEMA_ELEMENT_VALUE = "UPDATE_SCHEMA_ELEMENT_VALUE";
export var SET_TASK_ELEMENTS_VALUES = "SET_TASK_ELEMENTS_VALUES";
export var UPDATE_TASK_ELEMENTS_VALUES = "UPDATE_TASK_ELEMENTS_VALUES";
export var SET_JOB_ELEMENTS_VALUES = "SET_JOB_ELEMENTS_VALUES";
export var UPDATE_JOB_ELEMENTS_VALUES = "UPDATE_JOB_ELEMENTS_VALUES";
export var SET_TASK_ELEMENT_ERRORS = "SET_TASK_ELEMENT_ERRORS";
export var SET_JOB_ELEMENT_ERRORS = "SET_JOB_ELEMENT_ERRORS";
export var STORE_EDITOR_REFERENCES = "PARSE_EDITOR_TYPE";
export var SET_EDITOR_INITIALIZED = "SET_EDITOR_INITIALIZED";
export var SET_EDITOR_DISABLED = "SET_EDITOR_DISABLED";
